// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  User State
// -------------------------------
export interface UserState extends EntityState<any> {
  common?: any;
  globalUserInfo?: any;
}

// -------------------------------
//  User Adapter
// -------------------------------
export const UserAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  User Initial State
// -------------------------------
export const initialState: UserState = UserAdapter.getInitialState(
  {
    common: null,
    globalUserInfo: null,
  },
);
